import styled from "styled-components";

import { alpha, flexSpBetween, rem } from "@styles/Utilities.styled";


export const StyledPatients = styled.section`
  .header {
    position: sticky;
    top: 0;
    background-color: var(--clr-white);
    ${flexSpBetween}
    padding-top: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${alpha("var(--clr-black)", 0.1)};
    z-index: 2;

    h1 {
      font-weight: 500;
      font-size: ${rem(20)};
    }
  }
`;
